import { __read, __rest, __spreadArray } from "tslib";
import { Typography } from './Typography';
import { mq } from '../MediaQuery/MediaQuery';
export var makeCssObjectOfTextStyle = function (textStyle, velocityTheme) {
    var textSubVariants = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        textSubVariants[_i - 2] = arguments[_i];
    }
    var _a = textStyle, looseStyles = _a.loose, boldStyles = _a.bold, rest = __rest(_a, ["loose", "bold"]);
    var cssStyles = Object.entries(rest).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        acc[key] = typeof val === 'function' ? val(velocityTheme) : val;
        return acc;
    }, {});
    if (textSubVariants.includes('loose') && looseStyles) {
        Object.assign(cssStyles, makeCssObjectOfTextStyle(looseStyles, velocityTheme));
    }
    if (textSubVariants.includes('bold') && boldStyles) {
        Object.assign(cssStyles, makeCssObjectOfTextStyle(boldStyles, velocityTheme));
    }
    return cssStyles;
};
export var TypographyBreakpointNameList = [
    'mobile',
    'tablet',
    'desktop',
];
export function getTypographyCSS(velocityTheme, type, variant) {
    var textSubVariants = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        textSubVariants[_i - 3] = arguments[_i];
    }
    // could be a bit nicer to make it use mq.between (makes it a bit more complicated), unless we want use
    // inheritance (which we don't...)
    return TypographyBreakpointNameList.reduce(function (acc, typographyBreakpoint) {
        var styles = Typography[typographyBreakpoint][type][variant];
        acc[mq.min(typographyBreakpoint)] = makeCssObjectOfTextStyle.apply(void 0, __spreadArray([styles,
            velocityTheme], __read(textSubVariants)));
        return acc;
    }, {});
}
export function typographyMixin(type, variant) {
    var textSubVariants = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        textSubVariants[_i - 2] = arguments[_i];
    }
    return function (_a) {
        var scTheme = _a.theme;
        if (type === 'headline') {
            return getTypographyCSS(scTheme.velocity, 'headline', variant);
        }
        return getTypographyCSS.apply(void 0, __spreadArray([scTheme.velocity,
            'text', variant], __read(textSubVariants)));
    };
}
//# sourceMappingURL=Typography.utils.js.map